import { createSlice } from '@reduxjs/toolkit';
const initialState = {
// shouldTriggerRangesValidation: false,
// // // True - to force filling `rangesForSubmit` on mount.
// // shouldTriggerRangesValidation: true,
// shouldSubmitStockSettingForm: false,
// rangesForSubmit: undefined,
};
const warehousesSlice = createSlice({
    name: 'warehouses',
    initialState,
    reducers: {
    // triggerRangesValidation: (state) => {
    // 	state.shouldTriggerRangesValidation = true;
    // },
    // disableTriggerRangesValidation: (state) => {
    // 	state.shouldTriggerRangesValidation = false;
    // },
    // stopShouldSubmitStockSettingForm: (state) => {
    // 	state.shouldSubmitStockSettingForm = false;
    // },
    // prepareRangesForSubmit: (state, action: { payload: StockCellSelectable[] }) => {
    // 	const filteredFlat = action.payload.filter((cell) => cell.selectedBy !== null);
    // 	const rangeIds = [...new Set(filteredFlat.map((el) => el.selectedBy))];
    // 	const rangesForSubmit: StockCellKey[][] = [];
    // 	rangeIds.forEach((rangeId) => {
    // 		rangesForSubmit.push(
    // 			filteredFlat
    // 				.filter((el) => el.selectedBy === rangeId)
    // 				.map((cell) => ({ stockCellId: cell.stockCellId, sectorName: cell.sectorName, sectorX: cell.sectorX, sectorY: cell.sectorY }))
    // 		);
    // 	});
    // 	state.rangesForSubmit = rangesForSubmit;
    // 	// state.shouldSubmitStockSettingForm = true;
    // },
    // removeSubmittedRanges: (state) => {
    // 	state.rangesForSubmit = undefined;
    // },
    },
});
export const { actions: warehousesActions, reducer: warehousesStateReducer } = warehousesSlice;
